// AsyncStorage Polyfill para web usando localStorage
const PREFIX = '@AsyncStorage:';

const AsyncStorage = {
  setItem: async (key, value) => {
    try {
      localStorage.setItem(PREFIX + key, value);
      return true;
    } catch (error) {
      console.error('Error al guardar en AsyncStorage (web):', error);
      throw error;
    }
  },
  
  getItem: async (key) => {
    try {
      return localStorage.getItem(PREFIX + key);
    } catch (error) {
      console.error('Error al leer de AsyncStorage (web):', error);
      throw error;
    }
  },
  
  removeItem: async (key) => {
    try {
      localStorage.removeItem(PREFIX + key);
      return true;
    } catch (error) {
      console.error('Error al eliminar de AsyncStorage (web):', error);
      throw error;
    }
  },
  
  clear: async () => {
    try {
      // Solo limpiar claves con nuestro prefijo
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(PREFIX)) {
          localStorage.removeItem(key);
        }
      });
      return true;
    } catch (error) {
      console.error('Error al limpiar AsyncStorage (web):', error);
      throw error;
    }
  },
  
  getAllKeys: async () => {
    try {
      const keys = Object.keys(localStorage)
        .filter(key => key.startsWith(PREFIX))
        .map(key => key.substring(PREFIX.length));
      return keys;
    } catch (error) {
      console.error('Error al obtener claves de AsyncStorage (web):', error);
      throw error;
    }
  }
};

module.exports = AsyncStorage; 